import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchPositionsGroups = ({ accountId }) => get(`/accounts/${accountId}/positions-groups`);

export const addPositionsGroup = ({ accountId, positionsGroup }) =>
  post(`/accounts/${accountId}/positions-groups`, positionsGroup);

export const updatePositionsGroup = ({ accountId, positionsGroupId, positionsGroup }) =>
  patch(`/accounts/${accountId}/positions-groups/${positionsGroupId}`, positionsGroup);

export const deletePositionsGroup = ({ accountId, positionGroupsId }) =>
  httpDelete(`/accounts/${accountId}/positions-groups/${positionGroupsId}`);
